import { defineStore } from "pinia";
import federationsApi, { BillingDetails, FederationMemberData, FullFederationMetadata } from "../../Api/federationsApi";

export type FederationMenuSection = "federationDetails" | "federationMembers" | "billing" | "rankings";

export const useFederationDashboardStore = defineStore("federation-dashboard", {
    state() {
        return {
            userId: 0,
            federationId: "0",

            activeSection: "federationDetails" as FederationMenuSection,
            federationMetadata: null as null | FullFederationMetadata,

            federationMembers: [] as FederationMemberData[],
            billingDetails: {
                companyName: null,
                street: null,
                city: null,
                postalCode: null,
                country: null,
                taxId: null,
            } as BillingDetails,
            billingValidationErrors: {} as Record<string, string[]>,
        };
    },
    actions: {
        refreshFederationMetadata() {
            return federationsApi.getFederationMetadata(this.federationId).then(metadata => {
                this.federationMetadata = metadata;
            });
        },
        refreshFederationMembers() {
            return federationsApi.getFederationMembersListing(this.federationId).then(members => {
                this.federationMembers = members;
            });
        },
        refreshBillingDetails() {
            return federationsApi.getBillingDetails(this.federationId).then(response => {
                if (response.billingDetails) {
                    this.billingDetails = response.billingDetails;
                } else {
                    this.billingDetails = {
                        companyName: null,
                        street: null,
                        city: null,
                        postalCode: null,
                        country: null,
                        taxId: null,
                    };
                }
            });
        },
        clearBillingValidationErrors() {
            this.billingValidationErrors = {};
        },
        setBillingValidationErrors(errors: Record<string, string[]>) {
            this.billingValidationErrors = errors;
        },
    },
});
